const apiHost = 'http://localhost:4000/api'

export {
    apiHost
}